import React from 'react';
import { IconWrapper } from '../runtime';
export default IconWrapper('reload-icon', false, function (props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 49 48"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: props.strokeLinecap
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.223 16.525C35.28 11.995 30.178 9 24.375 9c-9.113 0-16.5 7.387-16.5 16.5S15.262 42 24.375 42s16.5-7.387 16.5-16.5"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: props.strokeLinejoin,
    d: "M33.375 18.5h7V12"
  })));
});